import { Link, useLocation } from "react-router-dom";
import { LifeBuoy } from "lucide-react";

// Always-visible way into Help (pages/Help.js), in the top bar beside the
// bells on every page. `compact` is the icon-only version for the mobile bar.
export default function HelpButton({ compact = false }) {
  const { pathname } = useLocation();
  const active = pathname === "/help";
  if (compact) {
    return (
      <Link to="/help" aria-label="Help" title="Help"
        className={`p-2 rounded-xl transition-all ${active ? "bg-primary-50 text-primary-700" : "text-secondary-500 hover:bg-primary-50 hover:text-primary-600"}`}>
        <LifeBuoy size={18} />
      </Link>
    );
  }
  return (
    <Link to="/help" title="Ask where to find anything"
      className={`mr-1 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm font-medium transition-all ${
        active ? "border-primary-300 bg-primary-50 text-primary-700" : "border-secondary-200 text-secondary-600 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"}`}>
      <LifeBuoy size={16} /> Help
    </Link>
  );
}
